module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Get Set Kit (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x 1', 'Power Hub', 'Pacchetto cavi'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['15Kwh LFP Battery x 1', 'Power Hub', 'Pacchetto cavi'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x 1', 'Power Hub', 'Pacchetto cavi'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '7346809602212',
        variantId: ['42347814584484', '42347814617252', '42347814650020'],
        capacity: 2,
        productName: '2kWh Power Kits',
        name: 'Get Set Kit (2kWh) ',
        discountPrice: 3898,
        originalPrice: 4898,
        unit: '€',
        includes: ['Batteria LFP da 2kWh x 1', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '7346809667748',
        variantId: ['42347815141540', '42347815174308', '42347815207076'],
        capacity: 4,
        productName: '4kWh Power Kits',
        name: 'Get Set Kit (4kWh) ',
        discountPrice: 5597,
        originalPrice: 7097,
        unit: '€',
        includes: ['Batteria LFP da 2kWh x 2', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '7346809700516',
        variantId: ['42347815272612', '42347815305380', '42347815338148'],
        capacity: 5,
        productName: '5kWh Power Kits',
        name: 'Get Set Kit (5kWh) ',
        discountPrice: 5998,
        originalPrice: 7498,
        unit: '€',
        includes: ['Batteria LFP da 5kWh x 1', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '7346809733284',
        variantId: ['42347815370916', '42347815403684', '42347815436452'],
        capacity: 10,
        productName: '10kWh Power Kits',
        name: 'Get Set Kit (10kWh) ',
        discountPrice: 9797,
        originalPrice: 12297,
        unit: '€',
        includes: ['Batteria LFP da 5kWh x 2', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '7346809766052',
        variantId: ['42347815469220', '42347815501988', '42347815534756'],
        capacity: 15,
        productName: '15kWh Power Kits',
        name: 'Get Set Kit (15kWh) ',
        discountPrice: 13596,
        originalPrice: 17096,
        unit: '€',
        includes: ['Batteria LFP da 5kWh x 3', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: 'Control and visualize your energy usage. ',
      discountPrice: 300,
      originalPrice: 538,
      unit: '€',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: 'AC/DC Smart Distribution Panel',
        desc: 'With 12 fused DC positions, and 6 AFCI protected AC positions you can manage the power distribution around your RV or tiny home. Control up to 6 DC positions from the EcoFlow app or Console.',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'AC/DC Smart Distribution Panel',
          desc: 'With 12 fused DC positions, and 6 AFCI protected AC positions you can manage the power distribution around your RV or tiny home. Control up to 6 DC positions from the EcoFlow app or Console.',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'AC Main Input',
            value: '16A Max, 230V, 3600W'
          }, {
            key: 'DC Main Input',
            value: '70A Max'
          }, {
            key: 'AC Output',
            value: '6 AC Positions, 10A Max Each'
          }, {
            key: 'DC Output',
            value: '12 Fused DC Positions (6 Positions Controllable via Power Kit Console & App) '
          }, {
            key: 'Operating Temperature',
            value: '-25°C-60°C'
          }, {
            key: 'Dimensions',
            value: '210 x 354 x 98 mm (Height x Width x Depth)'
          }, {
            key: 'Net Weight',
            value: '2.6kg'
          }, {
            key: 'Protection Level',
            value: 'IP21'
          }, {
            key: 'Testing and Certification',
            value: 'CE, UL, FCC, EMC Class B'
          }]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: 'Mounting Strap',
        desc: 'Mount your batteries safely and securely.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }, {
      productId: 2,
      variantId: '',
      name: 'Add power, control your system, and monitor energy usage.',
      discountPrice: 1600,
      originalPrice: 2355,
      unit: '€',
      subs: [{
        comboSubId: 'combo_2_sub_1',
        name: 'AC/DC Smart Distribution Panel',
        desc: 'With 12 fused DC positions, and 6 AFCI protected AC positions you can manage the power distribution around your RV or tiny home. Control up to 6 DC positions from the EcoFlow app or Console.',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'AC/DC Smart Distribution Panel',
          desc: 'With 12 fused DC positions, and 6 AFCI protected AC positions you can manage the power distribution around your RV or tiny home. Control up to 6 DC positions from the EcoFlow app or Console.',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'AC Main Input',
            value: '16A Max, 230V, 3600W'
          }, {
            key: 'DC Main Input',
            value: '70A Max'
          }, {
            key: 'AC Output',
            value: '6 AC Positions, 10A Max Each'
          }, {
            key: 'DC Output',
            value: '12 Fused DC Positions (6 Positions Controllable via Power Kit Console & App) '
          }, {
            key: 'Operating Temperature',
            value: '-25°C-60°C'
          }, {
            key: 'Dimensions',
            value: '210 x 354 x 98 mm (Height x Width x Depth)'
          }, {
            key: 'Net Weight',
            value: '2.6kg'
          }, {
            key: 'Protection Level',
            value: 'IP21'
          }, {
            key: 'Testing and Certification',
            value: 'CE, UL, FCC, EMC Class B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_2',
        name: 'EcoFlow Power Kits Console',
        desc: 'Control, monitor, and view your power consumption.',
        img: '/img/calculators/mm100/combo-console.jpg',
        imgH5: '/img/calculators/mm100H5/combo-console.jpg',
        details: {
          title: 'EcoFlow Power Kits Console',
          desc: 'Control, monitor, and view your power consumption.',
          img: '/img/calculators/mm100/combo-detail-console.jpg',
          imgH5: '/img/calculators/mm100H5/combo-console.jpg',
          specParams: [{
            key: 'Touch Screen (Diagonal)',
            value: '7 Inch (154.21x85.92mm) (Width x Height)'
          }, {
            key: 'Power Supply Voltage',
            value: '12 VDC'
          }, {
            key: 'Operating Temperature',
            value: '-25°C-60°C'
          }, {
            key: 'Dimensions',
            value: '113.3 x 204.5 x 22.35 mm (Height x Width x Depth)'
          }, {
            key: 'Net Weight',
            value: '450g'
          }, {
            key: 'Tests and Certifications',
            value: 'CE, UL, FCC, EMC Class B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_4',
        name: 'Mounting Strap',
        desc: 'Mount your batteries safely and securely.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }],
    // solar panel
    solarPack: [{
      productId: '7346811928740',
      variantId: '42347831656612',
      name: '2*100W Rigid Solar Panel + 2*Rigid Solar Mounting Feet',
      discountPrice: 179,
      originalPrice: 229,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*100W Rigid Solar Panel + 2*Rigid Solar Mounting Feet',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: 'Rated Power',
          value: '100 W (+/-5 W)'
        }, {
          key: 'Open Circuit Voltage',
          value: '20.3 V'
        }, {
          key: 'Short Circuit Current',
          value: '6.3 A'
        }, {
          key: 'Maximum Operating Voltage',
          value: '17.1 V'
        }, {
          key: 'Maximum Operating Current',
          value: '5.9 A'
        }, {
          key: 'Temperature Coefficient of Rated Power',
          value: '-0.39%/°C'
        }, {
          key: 'Temperature Coefficient of Open Circuit Voltage',
          value: '-0.33%/°C'
        }, {
          key: 'Temperature Coefficient of Short Circuit Current',
          value: '0.06%/°C'
        }, {
          key: 'Maximum System Voltage',
          value: '600 VDC (UL)'
        }, {
          key: 'Maximum Fuse Current',
          value: '15 A'
        }, {
          key: 'Solar Panel Weight',
          value: 'Approx. 6.2 kg (13.7 lbs)'
        }, {
          key: 'Dimensions',
          value: '98 x 58.6 x 3 cm'
        }]
      },
      question: {}
    }, {
      productId: '7346811961508',
      variantId: '42347831689380',
      name: '2*400W Rigid Solar Panel + 4*Rigid Solar Mounting Feet',
      discountPrice: 599,
      originalPrice: 799,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 800,
      // freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*400W Rigid Solar Panel + 4*Rigid Solar Mounting Feet',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: 'Rated Power',
          value: '400W (+/-3 W)'
        }, {
          key: 'Open Circuit Voltage',
          value: '37.10V'
        }, {
          key: 'Short Circuit Current',
          value: '13.79A'
        }, {
          key: 'Maximum Operating Voltage',
          value: '31.00V'
        }, {
          key: 'Maximum Operating Current',
          value: '12.90A'
        }, {
          key: 'Temperature Coefficient of Rated Power',
          value: '-0.38%/°C'
        }, {
          key: 'Temperature Coefficient of Open Circuit Voltage',
          value: '-0.35%/°C'
        }, {
          key: 'Temperature Coefficient of Short Circuit Current',
          value: '+0.06%/°C'
        }, {
          key: 'Maximum System Voltage',
          value: '1500V DC'
        }, {
          key: 'Maximum Fuse Current',
          value: '25A'
        }, {
          key: 'Operating Temp.',
          value: '-20°C-+50°C'
        }, {
          key: 'Solar Panel Weight',
          value: 'Approx. 21.8Kg'
        }, {
          key: 'Dimensions',
          value: '1722 × 1134 × 35 mm'
        }]
      },
      question: {}
    }, {
      productId: '7346811994276',
      variantId: '42347831722148',
      name: '1*100W Flexible Solar Panel',
      discountPrice: 129,
      originalPrice: 149,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*100W Flexible Solar Panel',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: 'Rated Power',
          value: '100 W (+/- 5 W)'
        }, {
          key: 'Open Circuit Voltage',
          value: '20.3 V'
        }, {
          key: 'Short Circuit Current',
          value: '6.3 A'
        }, {
          key: 'Maximum Operating Voltage',
          value: '17.1 V'
        }, {
          key: 'Maximum Operating Current',
          value: '5.9 A'
        }, {
          key: 'Temperature Coefficient of Rated Power',
          value: '-0.39%/°C'
        }, {
          key: 'Temperature Coefficient of Open Circuit Voltage',
          value: '-0.33%/°C'
        }, {
          key: 'Temperature Coefficient of Short Circuit Current',
          value: '0.06%/°C'
        }, {
          key: 'Maximum System Voltage',
          value: '600 VDC (UL)'
        }, {
          key: 'Maximum Fuse Current',
          value: '15 A'
        }, {
          key: 'Solar Panel Weight',
          value: 'Approx. 2.3 kg (5.1 lbs)'
        }, {
          key: 'Dimensions',
          value: '1,055 x 612 x 25 mm (41.5 x 24.1 x 1.0 in)'
        }]
      },
      question: {}
    }
    // {
    //     productId: '6618094960713',
    //     variantId: '39998021697609',
    //     name: '1*400W Portable Solar Panel',
    //     discountPrice: 1199,
    //     originalPrice: 1199,
    //     // discountRate: 0.8,
    //     unit: '€',
    //     number: 0,
    //     capacity: 400,
    //     locale: ['us', 'ca', 'au', 'jp'], // only for us site
    //     img: '/img/calculators/mm100/solar-400-portable.jpg',
    //     imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
    //     // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
    //     details: {
    //         title: '1*400W Portable Solar Panel',
    //         desc: '',
    //         img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
    //         imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
    //         specParams: [
    //             { key: 'Rated Power', value: '400W(+/-10W)' },
    //             { key: 'Open Circuit Voltage', value: '48V(Vmp 41V)' },
    //             { key: 'Short Circuit Current', value: '11A(Imp 9.8A)' },
    //             { key: 'Efficiency', value: '22.4 %' },
    //             { key: 'Cell Type', value: 'Monocrystalline silicon' },
    //             { key: 'Connector type', value: 'MC4' },
    //             { key: 'Weight', value: '46.3 lbs(21.0KG)' },
    //             { key: 'Solar Panel', value: '33.1lbs(15.0KG)' },
    //             {
    //                 key: 'Unfolded Dimensions',
    //                 value: '42.0 * 94.1 * 1.0 in (106.8 * 239.0 * 2.4cm)',
    //             },
    //             {
    //                 key: 'Folded Dimensions',
    //                 value: '42.0 * 24.4 * 1.0 in (106.8 * 62.0 * 2.4cm)',
    //             },
    //         ],
    //     },
    //     question: {},
    // },
    ],

    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      42347814584484: 'power-2kw.jpg',
      42347814617252: 'bundle-2kw-dp.jpg',
      42347814650020: 'bundle-2kw-all_us.jpg',
      42347815141540: 'power-4kw.jpg',
      42347815174308: 'bundle-4kw-dp.jpg',
      42347815207076: 'bundle-4kw-all_us.jpg',
      42347815272612: 'power-5kw.jpg',
      42347815305380: 'bundle-5kw-dp.jpg',
      42347815338148: 'bundle-5kw-all_us.jpg',
      42347815370916: 'power-10kw.jpg',
      42347815403684: 'bundle-10kw-dp.jpg',
      42347815436452: 'bundle-10kw-all_us.jpg',
      42347815469220: 'power-15kw.jpg',
      42347815501988: 'bundle-15kw-dp.jpg',
      42347815534756: 'bundle-15kw-all_us.jpg'
    },
    // solar price discount rate => 2022-06-22: not in use anymore
    // solarDiscountRate: {
    //     // product_id
    //     '6757458116681': {
    //         '0': 0.92,
    //         '1': 0.87,
    //         '2': 0.85,
    //     },
    //     '6757463720009': {
    //         '0': 0.87,
    //         '1': 0.84,
    //         '2': 0.82,
    //     },
    //     '6757464277065': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.85,
    //     },
    //     '6757469388873': {
    //         '0': 0.87,
    //         '1': 0.85,
    //         '2': 0.8,
    //     },
    //     '6757470011465': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.82,
    //     },
    // },

    // combo's original price under the bundle
    comboPrice: {
      // productId
      7346809602212: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7346809667748: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7346809700516: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7346809733284: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7346809766052: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      }
    },
    // common power kit's details
    powerDetails: {
      title: 'EcoFlow Power Hub ',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: 'The Power Hub is the heart of your Power Kit and saves valuable space in your van or off-grid build. Power Hub does the job of two MPPT solar charge controllers, a battery charger with MPPT, a DC-DC step-down converter, and an inverter-charger, all in one unit, making setup extremely simple. ',
      specParams: [{
        key: 'Net Weight',
        value: '14 kg'
      }, {
        key: 'Dimensions',
        value: '30 x 48 x 14 cm（Height x Width x Depth）'
      }, {
        key: 'Testing and Certification',
        value: 'CE, UL, FCC'
      }, {
        key: 'WI-FI',
        value: 'Supported'
      }, {
        key: 'Bluetooth',
        value: 'Supported'
      }, {
        key: 'AC Main Output/Frequency',
        value: 'Pure Sine Wave, 3600W (Surge 6000W), 230V, 50Hz/60Hz'
      }, {
        key: 'DC Main Output',
        value: '13.6V/70A 1000W Max; 26.4V/60A, 1500W Max'
      }, {
        key: 'AC Main Input',
        value: 'X-Stream fast charging 3000W Max, 16A Max'
      }, {
        key: 'AC Main Input Voltage/Frequency',
        value: '220-240V, 50Hz/60Hz'
      }, {
        key: 'Solar Charging Input',
        value: '15-150V 30A, 1600W Max'
      }, {
        key: 'Alternator Charging Input',
        value: '13V-60V, 60A, 1000W Max'
      }, {
        key: 'Optimal Operating Temperature',
        value: '20°C-30°C'
      }, {
        key: 'Discharge Temperature',
        value: '-25°C-60°C'
      }, {
        key: 'Charge Temperature',
        value: '-25°C-60°C'
      }, {
        key: 'Store Temperature',
        value: '-25°C-60°C'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: 'Additional run time was calculated based on an average of 80% solar panel input and 5hrs of sunlight.'
    },
    // installations
    // installOptions: [
    //     {
    //         variantId: 0,
    //         i18n: 'self',
    //     },
    //     {
    //         productId: '7346812027044',
    //         variantId: '42347831754916',
    //         i18n: 'expert',
    //         i18n_des: 'pro',
    //     },
    // ],

    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: false,
    wire: {
      name: 'Pacchetto cavi + Mounting Strap'
    },
    installTerms: {
      title: 'Free Installation Terms and Conditions*',
      text: '1. Orders placed between 2022.08.25 to 2022.09.30 will be qualified for this limited-time offer. \n2. For addresses within the EcoFlow installer network, EcoFlow would contact you to make an appointment for free installation service. \n3. For addresses outside the EcoFlow installer network, customers can choose local installers. EcoFlow will reimburse the installation cost of Power Kits products.',
      sup: '*EcoFlow reserves the rights of final interpretation.'
    }
  };
};